import {makeAutoObservable} from "mobx";

class AddressStore {
    list = [];

    constructor() {
        makeAutoObservable(this)
    }
}

const store = new AddressStore()

export default store
